import React from "react";

const industries = [
  "Abrasives",
  "AC/DC EV Charging Stations",
  "Accounting Services",
  "Adhesives",
  "Alloying",
  "Auto Components",
  "Automotive Industries",
  "Battery Manufacturers",
  "Breaking Systems",
  "Bulk Moulding Components",
  "Cables and Wires",
  "Car Carpets",
  "Catering",
  "Chemical Manufacturers",
  "CNC Machines Manufacturer",
  "CNC Machining",
  "Coating",
  "Cold Storage",
  "Constructions -Road, Industrial and Residential",
  "Custom Clearances",
  "Design Engineering",
  "Detailed Engineering",
  "Electrical and Electronics Assemblies",
  "Electrical Panels",
  "Embedded Software Solutions",
  "Engineering Plastics",
  "Energy Meters",
  "EOT Cranes",
  "EPC",
  "Exporters",
  "Extrusion",
  "Fabrication",
  "Fibre Optic Cables",
  "Fleet Operators",
  "Food Outlets",
  "Freight Forwarders",
  "FRP Products",
  "Furniture Manufacturing",
  "Goods Transports",
  "Hardware and Software solutions",
  "Heat Treatment",
  "Implant-abutment",
  "Jewellery Showroom",
  "Machining",
  "Manpower Agencies",
  "Medical Devices",
  "Packing Industries",
  "Painting",
  "Panchayat Board",
  "Paper",
  "Parcel Services",
  "Pipes & Fittings",
  "Plant Design Engineering",
  "Plastic Injection Moulding",
  "Pressure Die Casting",
  "Printing",
  "PVC Granules",
  "Radar Ventures",
  "Retailers and Wholesale",
  "Rubber Moulding",
  "Sandwiched Concrete Panels",
  "Security Agencies",
  "Sheet Metal Forming",
  "Solar / Wind Solutions",
  "Surveyors",
  "Textile",
  "Thermoplastic Polyurethanes",
  "Tourism and Travels",
  "Transformers",
  "Transporters",
  "Valves",
  "Vehicle Body Buildings",
  "Vehicle Maintenance",
  "Water Treatment",
];

const Industries = () => {
  return (
    <section className="industries-section">
      <div className="container">
        <h2 className="title">Industries We Support</h2>
        <div style={{textAlign:"left"}}>
        <p>
            At TRIO, we take pride in serving a diverse range of industries, helping businesses 
            meet regulatory requirements, achieve compliance, and optimize their operations. From 
            manufacturing and engineering to automotive, electronics, construction, and beyond, 
            we provide expert guidance tailored to each sector's unique challenges. Whether you're 
            in product development, logistics, retail, or industrial solutions, our specialized 
            services ensure smooth operations and market success.Explore the industries we support 
            below and see how we can help your business thrive!
            </p>   
            </div> 
            <br/>
        <div className="industries-list">
            
          {industries.map((industry, index) => (
            <div key={index} className="industry-item">
              {industry}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
